import * as THREE from 'three';
import {getRadians} from '../../../../utils';

function addShipModel(scene, shipModelUrl, loadingManager) {

    const loader = new THREE.ObjectLoader(loadingManager);
    loader.load(shipModelUrl, handleLoad);

    function handleLoad(object) {
        object.name = 'shipModel';
        object.scale.multiplyScalar(0.00099);
        object.position.y = 0.10;
        object.position.x = -0.10;
        object.rotation.x = getRadians(180);
        object.rotation.y = getRadians(90);

        scene.add(object);
    }
}

export default addShipModel;